import { z } from 'zod';

export const NotificationTypeSchema = z.enum([
  'EMAIL_VERIFICATION',
  'REGISTRATION_WELCOME',
  'ADMIN_INVITE',
  'MAGIC_LINK',
  'PASSWORD_RESET',
  'BOOKING_CONFIRMATION',
  'BOOKING_REMINDER',
  'BOOKING_DAY_BEFORE_REMINDER',
  'PAYMENT_RECEIPT',
  'CANCELLATION_CONFIRMATION',
  'MEMBERSHIP_WELCOME',
  'MEMBERSHIP_CANCELLED',
  'PAYMENT_FAILED',
  'CARD_EXPIRING',
  'LOCK_OPERATIONAL_ALERT',
]);

export const NotificationChannelSchema = z.enum(['EMAIL', 'SMS', 'BOTH']);

export const UpdateNotificationTemplateInputSchema = z.object({
  name: z.string().min(1).max(120).optional(),
  subject: z.string().min(1).max(200).optional(),
  htmlBody: z.string().min(1).optional(),
  textBody: z.string().min(1).optional(),
  smsBody: z.string().max(480).nullable().optional(),
  isEnabled: z.boolean().optional(),
});

export type UpdateNotificationTemplateInput = z.infer<typeof UpdateNotificationTemplateInputSchema>;
